import { Section } from "@/components/ui/Section";

export default function About() {
  return (
    <Section
      eyebrow="// About"
      title="We build the agency we wish existed."
      subtitle="INFINI Marketing is a lead-generation agency with an uncommon rule: we will not run paid media for a brand that can't hold it. We believe trust is the prerequisite to growth — not the reward of it."
    >
      <div className="grid gap-8 md:grid-cols-2">
        <div className="panel p-8">
          <div className="eyebrow mb-3">// Belief</div>
          <p className="text-silver-200 leading-relaxed">
            Every marketing dollar that hits a weak brand leaks. We built INFINI X —
            the operating system behind this agency — to stop the leak. Phase 1 is
            always trust. Phase 2 only unlocks when the Brand Strength Score says
            you're ready.
          </p>
        </div>
        <div className="panel p-8">
          <div className="eyebrow mb-3">// Method</div>
          <p className="text-silver-200 leading-relaxed">
            Spark, our AI strategist, walks every client through an 11-stage discovery
            framework. BSS keeps everyone honest. The service catalog keeps delivery
            consistent. The ROI dashboard keeps us accountable.
          </p>
        </div>
      </div>
    </Section>
  );
}
